/* eslint-disable react-hooks/exhaustive-deps */
import debounce from "lodash.debounce";
import PropTypes from "prop-types";
import React, { useCallback } from "react";

import Label from '../formsUi/common/label/Label';
import TextArea from '../formsUi/textArea/TextArea';
import ValidationMessage from '../formsUi/common/validation/ValidationMessage';

const FormTextAreaControls = ({
    keyId,
    dataField,
    labelName,
    name,
    value,
    error,
    formSetting,
    overRideProps,
    isRequired,
    fieldSetting,
    onChange,
    onBlur
}) => {

    const debouncedOnChange = useCallback(
        debounce((dataField, value) => {
            onChange(dataField, value);
        },
            fieldSetting?.debounceTime ? fieldSetting?.debounceTime : 10
        ), // Adjust the delay as needed 
        [onChange]);

    const handleInputChange = (e) => {
        if (onChange) {
            if (fieldSetting?.debounceTime) {
                debouncedOnChange(dataField, e.target.value);
            } else {
                onChange(dataField, e.target.value);
            }
        }
    };

    const handleOnBlur = () => {
        onBlur(dataField);
    };

    return (
        <div className="input-field-sec" key={keyId}>
            {fieldSetting?.subTitle ? (
                <div className="section-title">
                    <h5>{fieldSetting.subTitle}</h5>
                </div>
            ) : ("")}
            <div className="input-label-part">
                {labelName && labelName !== "" && (
                    <Label labelName={labelName} htmlFor={name} isRequired={isRequired} />
                )}
                <TextArea
                    {...fieldSetting}
                    name={name}
                    key={keyId}
                    value={value}
                    onChange={handleInputChange}
                    onBlur={handleOnBlur}
                    isDisable={
                        formSetting?.isViewOnly ||
                        fieldSetting?.isDisable ||
                        overRideProps?.isDisable
                    }
                    readOnly={fieldSetting?.isReadOnly}
                />
            </div>
            <div className="textarea-info-bar">
                <ValidationMessage error={error || ""} />
                {fieldSetting?.maxLength ? (
                    <span className={`textarea-max-info ${(value?.length || 0) > fieldSetting.maxLength ? "is-exceeded" : ""}`}>
                        {fieldSetting?.showCharCount
                            ? `${value?.length || 0} / ${fieldSetting.maxLength} Max. Characters`
                            : `Max. Characters : ${fieldSetting.maxLength}`}
                    </span>
                ) : null}
            </div>
        </div>
    );
};

FormTextAreaControls.propTypes = {
    keyId: PropTypes.string.isRequired,
    dataField: PropTypes.string.isRequired,
    labelName: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    error: PropTypes.string,
    formSetting: PropTypes.object,
    overRideProps: PropTypes.object,
    isRequired: PropTypes.bool,
    fieldSetting: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired
};

export default FormTextAreaControls;